import intermind from '../../../index';

export class RecordingResource {
  async start(roomId: string): Promise<void> {
    await intermind.httpClient.post(`/rooms/${roomId}/recordings/start`);
  }

  async stop(roomId: string): Promise<void> {
    await intermind.httpClient.post(`/rooms/${roomId}/recordings/stop`);
  }

  async createToken(conferenceId: string): Promise<string> {
    const { data } = await intermind.httpClient.get(`/conferences/${conferenceId}/recordings/tokens`);
    return data.token;
  }
}
